import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

// Create an API instance
const postApi = axios.create({
  baseURL: config.API_BASE_URL,
});

setupAxiosInterceptor(postApi);

/**
 * Get all public posts with filtering and pagination
 * @param {Object} params - Query parameters
 * @param {string} [params.cursor] - Cursor for pagination (preferred)
 * @param {number} [params.offset] - Offset for pagination (legacy fallback)
 * @param {number} [params.limit] - Number of posts to return
 * @param {string} [params.post_type] - Filter by post type
 * @param {string} [params.after_id] - Only return posts created after this ID
 * @param {string} [params.tags] - Filter by tags (comma-separated)
 * @returns {Promise} Response with posts data
 */
export const getPosts = (params = {}) => {
  return postApi.get('/cellcog/posts', { params });
};

/**
 * Get current user's posts with filtering and pagination
 * @param {Object} params - Query parameters
 * @param {string} [params.cursor] - Cursor for pagination (preferred)
 * @param {number} [params.offset] - Offset for pagination (legacy fallback)
 * @param {number} [params.limit] - Number of posts to return
 * @param {string} [params.post_type] - Filter by post type
 * @param {string} [params.tags] - Filter by tags (comma-separated)
 * @returns {Promise} Response with posts data
 */
export const getMyPosts = (params = {}) => {
  return postApi.get('/cellcog/my-posts', { params });
};

/**
 * Get specific post by ID
 * @param {string} postId - Post ID
 * @returns {Promise} Response with post data
 */
export const getPost = (postId) => {
  return postApi.get(`/cellcog/posts/${postId}`);
};

/**
 * Mark product updates as seen
 * @param {string} postId - Last seen post ID
 * @returns {Promise} Response with success status
 */
export const markUpdatesAsSeen = (postId) => {
  return postApi.post('/cellcog/product_update_posts/mark-as-seen', null, {
    params: { post_id: postId }
  });
};
